$(function () {

  $('.js-slider').slick({
    dots: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: '.js-thumb'
  });
  $('.js-thumb').slick({
    arrows: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.js-slider',
    focusOnSelect: true
  });

  $(document).ready(function() {
    $('.inline-popup-link').magnificPopup({
      type: 'inline',
      midClick: true,
      // gallery: {
      //   enabled: true,
      //   navigateByImgClick: true,
      //   preload: [0, 1]
      // }
    });
  });

  $(window).on('load', function () {
    var size = $('.aw-alider-thumb .slick-slide').length;
    if (size > 17) {
      console.log('ok');
      $('.js_button').show();
    } else {
      $('.js_button').hide();
    }
  });
  $('.js_button').on('click', function () {
    $('.aw-alider-thumb .slick-slide:nth-child(n+13)').show();
    $(this).hide();
  });

  $(window).on('load', function () {
    var productHeight = $('.product-grid-product-template').outerHeight();
    console.log(productHeight);
    $(window).on( 'scroll', function () {
      if ( $(this).scrollTop() < productHeight ) {
        $('#product_goCartbutton').fadeOut();
      } else {
        $('#product_goCartbutton').fadeIn();
      }
    });
    var headerHeight = $('header').outerHeight();
    $('a[href^="#"].js_scroll').click(function() {
      var href= $(this).attr("href");
      var target = $(href);
      var position = target.offset().top - headerHeight;
      $('body,html').stop().animate({scrollTop:position}, 300);   
      return false;
    });
  });

});